import { connect } from "react-redux";
import { ApplicationState } from "store";
import {
    actionCreators as uiActionCreators,
    getActiveNavigationComponent,
    getFastTrackStatus,
    getRubberbandItem,
    getSpiralItem,
} from "ui/store";
import {
    getBackCoverImage,
    getCoverImage,
    getCustomBackImage,
    getCustomCoverImage,
    getSelectedLayout,
} from "burde-api-content/store";
import {
    actionCreators,
    getCalendar,
    getCalendarType,
} from "page/calendar/store";
import ControlsArea from "./controls-area";
import { withRouter } from "react-router";

const mapStateToProps = (state: ApplicationState) => ({
    activeComponent: getActiveNavigationComponent(state),
    calendar: getCalendar(state),
    fastTrackStatus: getFastTrackStatus(state),
    calendarLayout: getSelectedLayout(state),
    coverImage: getCoverImage(state),
    backCoverImage: getBackCoverImage(state),
    customCoverImage: getCustomCoverImage(state),
    customBackImage: getCustomBackImage(state),
    spiralItem: getSpiralItem(state),
    rubberbandItem: getRubberbandItem(state),
    calendarType: getCalendarType(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};

const connectedComponent = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ControlsArea);

export default withRouter(connectedComponent);
